<template>
  <a-modal
      :title="`年级/班级管理【${bizOrg.name}】`"
      :width="640"
      v-model="visible"
      :bodyStyle="{ maxHeight: '700px', overflowY: 'auto' }"
      @cancel="handleCancel"
  >
    <a-card style="margin-top: 20px" :title="grade.name" v-for="(grade, gIndex) in grades" key="gIndex">
      <template v-for="(className, cIndex) in grade.classes">
        <a-tag>
          {{ className }}
        </a-tag>
      </template>
<!--      <template v-if="inputVisible">
        <a-input
            ref="input"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            :value="inputValue"
            @change="handleInputChange"
            @blur="handleInputConfirm"
            @keyup.enter="handleInputConfirm"
        />
        <a-button style="margin-left: 10px" type="dashed" shape="circle" icon="check" size="small"/>
        <a-button type="dashed" shape="circle" icon="close" size="small" @click="handleCloseInput" />
      </template>
      <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
        <a-icon type="plus"/>
        添加班级
      </a-tag>-->
    </a-card>
    <template #footer>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSubmit">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import userService from '@/service/user.js';
import {ref, reactive, nextTick} from 'vue';
import {PlusOutlined} from '@ant-design/icons-vue';

export default {
  data() {
    return {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 13}
      },
      visible: false,
      inputC: -1,
      inputG: -1,
      inputVisible: false,
      inputValue: '',

      bizOrg: {},
      grades: []
    }
  },
  methods: {
    showModal(bizOrg) {
      this.visible = true

      this.bizOrg = bizOrg
      this.grades = bizOrg.grades

      this.$nextTick(() => {
        this.form.setFieldsValue({
          pocketNo: formData.pocketNo || '',
          labelNo1: (formData.labelNos && formData.labelNos[0]) || '',
          labelNo2: (formData.labelNos && formData.labelNos[1]) || '',
          labelNo3: (formData.labelNos && formData.labelNos[2]) || ''
        })
      })
    },

    handleSubmit() {
      this.visible = false
      this.inputVisible = false
    },
    handleCancel() {
      this.visible = false
      this.inputVisible = false
    },

    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      console.log(tags);
      this.tags = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      });
    },
    handleCloseInput() {
      Object.assign(this, {
        inputVisible: false,
        inputValue: '',
      });
    },
  }
}
</script>